export default {
	'date': '[String]',
	
	'buildingGuid': '[String]',
	'floorGuid': '[String]',
	'roomGuid': '[String]',
	'tableGuid': '[String]',
	
	'teamGuid': '[String]',
	'employeeGuid': '[String]',
}
